import { AbstractParentEntity } from "./AbstractParentEntity";
import { PerformancePlan } from "./tsadv$PerformancePlan";
import { CompetenceTemplate } from "./tsadv$CompetenceTemplate";
import { Assessment } from "./tsadv$Assessment";
import { Test } from "./tsadv$Test";
import { PersonGroupExt } from "./base$PersonGroupExt";
export class AssessmentTemplate extends AbstractParentEntity {
  static NAME = "tsadv$AssessmentTemplate";
  assessmentTemplateName?: string | null;
  performancePlan?: PerformancePlan | null;
  selfAssessment?: boolean | null;
  managerAssessment?: boolean | null;
  participantAssessment?: boolean | null;
  competenceTemplate?: CompetenceTemplate | null;
  assessment?: Assessment[] | null;
  goalWeight?: any | null;
  competenceWeight?: any | null;
  managerTest?: Test | null;
  workerTest?: Test | null;
  participantTest?: Test | null;
  nameLangValue?: string | null;
  nameLangValue1?: string | null;
  nameLangValue2?: string | null;
  nameLangValue3?: string | null;
  nameLangValue4?: string | null;
  nameLangValue5?: string | null;
  description1?: string | null;
  description2?: string | null;
  description3?: string | null;
  description4?: string | null;
  description5?: string | null;
  dateFrom?: any | null;
  dateTo?: any | null;
  author?: PersonGroupExt | null;
}
export type AssessmentTemplateViewName =
  | "_base"
  | "_local"
  | "_minimal"
  | "assessmentTemplate.browse"
  | "assessmentTemplate.edit"
  | "assessmentTemplate.filter"
  | "assessmentTemplateForCard";
export type AssessmentTemplateView<
  V extends AssessmentTemplateViewName
> = V extends "_base"
  ? Pick<
      AssessmentTemplate,
      | "id"
      | "nameLangValue"
      | "nameLangValue1"
      | "nameLangValue2"
      | "nameLangValue3"
      | "assessmentTemplateName"
      | "selfAssessment"
      | "managerAssessment"
      | "participantAssessment"
      | "goalWeight"
      | "competenceWeight"
      | "nameLangValue4"
      | "nameLangValue5"
      | "description1"
      | "description2"
      | "description3"
      | "description4"
      | "description5"
      | "dateFrom"
      | "dateTo"
      | "legacyId"
      | "organizationBin"
      | "integrationUserLogin"
    >
  : V extends "_local"
  ? Pick<
      AssessmentTemplate,
      | "id"
      | "assessmentTemplateName"
      | "selfAssessment"
      | "managerAssessment"
      | "participantAssessment"
      | "goalWeight"
      | "competenceWeight"
      | "nameLangValue1"
      | "nameLangValue2"
      | "nameLangValue3"
      | "nameLangValue4"
      | "nameLangValue5"
      | "description1"
      | "description2"
      | "description3"
      | "description4"
      | "description5"
      | "dateFrom"
      | "dateTo"
      | "legacyId"
      | "organizationBin"
      | "integrationUserLogin"
    >
  : V extends "_minimal"
  ? Pick<
      AssessmentTemplate,
      | "id"
      | "nameLangValue"
      | "nameLangValue1"
      | "nameLangValue2"
      | "nameLangValue3"
    >
  : V extends "assessmentTemplate.browse"
  ? Pick<
      AssessmentTemplate,
      | "id"
      | "assessmentTemplateName"
      | "selfAssessment"
      | "managerAssessment"
      | "participantAssessment"
      | "goalWeight"
      | "competenceWeight"
      | "nameLangValue1"
      | "nameLangValue2"
      | "nameLangValue3"
      | "nameLangValue4"
      | "nameLangValue5"
      | "description1"
      | "description2"
      | "description3"
      | "description4"
      | "description5"
      | "dateFrom"
      | "dateTo"
      | "legacyId"
      | "organizationBin"
      | "integrationUserLogin"
      | "performancePlan"
      | "competenceTemplate"
      | "managerTest"
      | "workerTest"
      | "participantTest"
      | "selfAssessment"
      | "managerAssessment"
      | "participantAssessment"
      | "assessmentTemplateName"
    >
  : V extends "assessmentTemplate.edit"
  ? Pick<
      AssessmentTemplate,
      | "id"
      | "assessmentTemplateName"
      | "selfAssessment"
      | "managerAssessment"
      | "participantAssessment"
      | "goalWeight"
      | "competenceWeight"
      | "nameLangValue1"
      | "nameLangValue2"
      | "nameLangValue3"
      | "nameLangValue4"
      | "nameLangValue5"
      | "description1"
      | "description2"
      | "description3"
      | "description4"
      | "description5"
      | "dateFrom"
      | "dateTo"
      | "legacyId"
      | "organizationBin"
      | "integrationUserLogin"
      | "selfAssessment"
      | "managerAssessment"
      | "participantAssessment"
      | "competenceTemplate"
      | "assessmentTemplateName"
      | "competenceWeight"
      | "goalWeight"
      | "managerTest"
      | "workerTest"
      | "participantTest"
      | "performancePlan"
      | "author"
    >
  : V extends "assessmentTemplate.filter"
  ? Pick<AssessmentTemplate, "id" | "assessmentTemplateName">
  : V extends "assessmentTemplateForCard"
  ? Pick<
      AssessmentTemplate,
      | "id"
      | "assessmentTemplateName"
      | "selfAssessment"
      | "managerAssessment"
      | "participantAssessment"
      | "goalWeight"
      | "competenceWeight"
      | "nameLangValue1"
      | "nameLangValue2"
      | "nameLangValue3"
      | "nameLangValue4"
      | "nameLangValue5"
      | "description1"
      | "description2"
      | "description3"
      | "description4"
      | "description5"
      | "dateFrom"
      | "dateTo"
      | "legacyId"
      | "organizationBin"
      | "integrationUserLogin"
      | "assessment"
      | "competenceTemplate"
    >
  : never;
